import { enums } from "@fraction/shared";
import { MediumText } from "src/components/v1";
import { cn } from "src/utilities/shadcnUtils";

const STATUS_STYLES: Record<enums.ApplicationTaskStatus, string> = {
  [enums.ApplicationTaskStatus.COMPLETE]: "bg-green-500 border-green-500 text-white",
  [enums.ApplicationTaskStatus.TODO]: "bg-transparent border-yellow-500 text-yellow-500",
  [enums.ApplicationTaskStatus.IN_PROGRESS]: "bg-transparent border-green-500 text-green-500",
  [enums.ApplicationTaskStatus.NOT_APPLICABLE]: "bg-transparent border-gray-600 text-gray-600",
  [enums.ApplicationTaskStatus.FAILED]: "bg-red-500 border-red-500 text-white",
  [enums.ApplicationTaskStatus.TO_FIX]: "bg-transparent border-red-500 text-red-500",
  [enums.ApplicationTaskStatus.DEPRECATED]: "bg-transparent border-red-500 text-red-500",
};

const CONTAINER = "rounded-[5px] border border-solid justify-center items-center px-[10px] py-[5.5px] w-fit";

export const TASK_STATUS_CONVERTER = {
  [enums.ApplicationTaskStatus.COMPLETE]: "Complete",
  [enums.ApplicationTaskStatus.TODO]: "To do",
  [enums.ApplicationTaskStatus.IN_PROGRESS]: "In progress",
  [enums.ApplicationTaskStatus.NOT_APPLICABLE]: "N/A",
  [enums.ApplicationTaskStatus.FAILED]: "Failed",
  [enums.ApplicationTaskStatus.TO_FIX]: "To fix",
  [enums.ApplicationTaskStatus.DEPRECATED]: "",
};

const TaskStatus = ({ status }: { status: enums.ApplicationTaskStatus }) => (
  <div className={cn(CONTAINER, STATUS_STYLES[status])}>
    <MediumText className={cn("text-[10px] text-center", STATUS_STYLES[status])}>
      {TASK_STATUS_CONVERTER[status]}
    </MediumText>
  </div>
);

export default TaskStatus;
